// extracted by mini-css-extract-plugin
export default {"container":"styles_container__8ki7e","vehicleContainer":"styles_vehicleContainer__9svEp"};